// extracted by mini-css-extract-plugin
module.exports = {"clicker_picker":"styles_clicker_picker__sGff2"};